<template>
  <div id="formulir">
    <BreadcrumbStep />
        
    <h5 class="my-5 text-center">
      <i class="fa fa-th-list text-primary mr-2" /> Pengisian Formulir
    </h5>

    <!-- konfirmasi form online/offline -->
    <div
      class="card"
      v-if="!showForm && !showFormJenisPelaporan && hasForm"
    >
      <div class="card-body">
        <div class="empty-state">
          <div class="empty-state-icon">
            <i class="fas fa-info" />
          </div>
          <h2>Informasi Pengisian Formulir</h2>
          <p class="lead">
            Formulir dapat diisi secara <b>online</b> maupun <b>offline</b> (manual). Informasi mengenai panduan membuat permohonan
            dapat dilihat di
            <router-link to="/panduan/cara-membuat-permohonan-dokumen-kependudukan">
              Panduan Membuat Permohonan
            </router-link>.
          </p>

          <div class="row mt-3">
            <div class="col-sm-6">
              <div
                class="card-item card"
                @click="initForm"
              >
                <div class="card-body">
                  <div class="d-flex">
                    <div class="card-icon mr-3 text-center">
                      <img :src="require('./../../assets/img/icon/computer.png')">
                    </div>
                    <div style="width: 70%">
                      <h6>Isi Formulir Online</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div
                class="card-item card"
                @click="formManual"
              >
                <div class="card-body">
                  <div class="d-flex">
                    <div class="card-icon mr-3 text-center">
                      <img :src="require('./../../assets/img/icon/pencil.jpg')">
                    </div>
                    <div style="width: 70%">
                      <h6>Isi Formulir Secara Offline (Manual)</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="alert alert-primary alert-has-icon"
      v-if="showForm && hasForm"
    >
      <div class="alert-icon">
        <i class="far fa-lightbulb" />
      </div>
      <div class="alert-body">
        <div class="alert-title">
          Informasi
        </div>
        Silahkan isi setiap form dengan baik dan benar, kemudian klik simpan.
        Setelah disimpan, pastikan formulir berubah berwarna hijau.
      </div>
    </div>

    <div
      class="card"
      v-if="showFormJenisPelaporan && hasForm"
    >
      <div class="card-header">
        <h4>Jenis Pelaporan</h4>
      </div>
      <div class="card-body">
        <FormJenisPelaporan @loadForm="loadForm" />
      </div>
    </div>

    <div
      class="list-formulir"
      role="tablist"
      v-if="showForm && hasForm"
    >
      <b-card
        no-body
        class="mb-1"
        v-for="f in dataPermohonan.form"
        :key="f.id"
      >
        <b-card-header
          header-tag="header"
          class="p-0"
          role="tab"
          style="min-height:inherit;border-radius:3px;cursor:pointer"
        >
          <div
            v-b-toggle="'form-'+f.id"
            class="p-3 d-flex"
            :class="{'bg-success text-white' : f.form_data}"
            style="width:100%;border-radius:3px"
          >
            <b :class="{'text-primary': !f.form_data, 'text-white':f.form_data}">
              {{ f.nama_form }} <span
                v-if="f.is_wajib === 1"
                class="text-dark"
              >(Wajib)</span>
            </b>
            <div style="margin-left:auto">
              <i
                class="fa text mr-2" 
                :class="{'fa-check-circle' : f.form_data, 'fa-info-circle text-warning' : !f.form_data}"
              />
            </div>
          </div>
        </b-card-header>
        <b-collapse
          :id="'form-'+f.id"
          role="tabpanel"
          accordion="list-formulir"
        >
          <b-card-body>
            <component
              :is="f.component"
              @handleSuccess="handleSuccess"
              :is-wajib="f.is_wajib"
              :data="f.form_data"
            />
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <div class="row mt-5">
      <div class="col-6 pr-0">
        <button
          class="btn btn-danger"
          @click="setStep(2)"
          disabled
        >
          <i class="fa fa-angle-left mr-2" />Kembali
        </button>
      </div>
      <div class="col-6 text-right pl-0">
        <button
          id="btnNext"
          v-if="allFormValid"
          class="btn btn-primary"
          @click="nextStep"
        >
          Selanjutnya<i class="fa fa-angle-right pl-2" />
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import swal from 'sweetalert'
import BreadcrumbStep from './BreadcrumbStep.vue'

import FormJenisPelaporan from './../form/Pelaporan/FormJenisPelaporan.vue'
import FormPelaporanKelahiran from './../form/Pelaporan/FormPelaporanKelahiran.vue'
import FormPelaporanCapilLuarNKRI from './../form/Pelaporan/FormPelaporanCapilLuarNKRI.vue'
import FormPelaporanDataOrangtua from './../form/Pelaporan/FormPelaporanDataOrangtua.vue'
import FormPelaporanKematian from './../form/Pelaporan/FormPelaporanKematian.vue'
import FormPelaporanPelapor from './../form/Pelaporan/FormPelaporanPelapor.vue'
import FormPelaporanSaksi from './../form/Pelaporan/FormPelaporanSaksi.vue'
import FormPelaporanLahirMati from './../form/Pelaporan/FormPelaporanLahirMati.vue'
import FormPelaporanPembetulanPembatalanAkta from './../form/Pelaporan/FormPelaporanPembetulanPembatalanAkta.vue'
import FormPelaporanPengakuanAnak from './../form/Pelaporan/FormPelaporanPengakuanAnak.vue'
import FormPelaporanPengangkatanAnak from './../form/Pelaporan/FormPelaporanPengangkatanAnak.vue'
import FormPelaporanPengesahanAnak from './../form/Pelaporan/FormPelaporanPengesahanAnak.vue'
import FormPelaporanPerceraian from './../form/Pelaporan/FormPelaporanPerceraian.vue'
import FormPelaporanPeristiwaPenting from './../form/Pelaporan/FormPelaporanPeristiwaPenting.vue'
import FormPelaporanPerkawinan from './../form/Pelaporan/FormPelaporanPerkawinan.vue'
import FormPelaporanPerubahanNama from './../form/Pelaporan/FormPelaporanPerubahanNama.vue'
import FormPelaporanPerubahanStatusKewarganegaraan from './../form/Pelaporan/FormPelaporanPerubahanStatusKewarganegaraan.vue'
import FormPelaporanSubjekAktaKedua from './../form/Pelaporan/FormPelaporanSubjekAktaKedua.vue'
import FormPelaporanSubjekAktaKesatu from './../form/Pelaporan/FormPelaporanSubjekAktaKesatu.vue'
import FormBiodata from './../form/Biodata/FormBiodata.vue'
import FormBiodataWni from './../form/BiodataWni/FormBiodataWni.vue'
import FormPendaftaranKependudukan from './../form/PendaftaranKependudukan/FormPendaftaranKependudukan.vue'
import FormPendaftaranPerpindahanPenduduk from './../form/PendaftaranPerpindahanPenduduk/FormPendaftaranPerpindahanPenduduk.vue'
import FormSkPindahLuarNegeri from './../form/SkPindahLuarNegeri/FormSkPindahLuarNegeri.vue'
import FormSpPerubahanData from './../form/SpPerubahanData/FormSpPerubahanData.vue'
import FormSpTidakMemilikiDokumen from './../form/SpTidakMemilikiDokumen/FormSpTidakMemilikiDokumen.vue'
import FormSptjmKawinBelumCatat from './../form/SptjmKawinBelumCatat/FormSptjmKawinBelumCatat.vue'
import FormSptjmKelahiran from './../form/SptjmKelahiran/FormSptjmKelahiran.vue'
import FormSptjmSuamiIstri from './../form/SptjmSuamiIstri/FormSptjmSuamiIstri.vue'
import FormPendudukNonPermanen from './../form/PendudukNonPermanen/FormPendudukNonPermanen.vue'



export default {
    data() {
        return {
            allFormValid: true,
            showForm: false,
            showFormJenisPelaporan: false,
            hasForm: false, // flag apakah layanan ini memiliki syarat form yang harus diisi, kalau ada, apakah isi form online/manual, kalau gak, langsung redirect ke upload berkas aja
        }
    },
    components: {
        BreadcrumbStep,
        FormJenisPelaporan,
        FormPelaporanKelahiran,
        FormPelaporanCapilLuarNKRI,
        FormPelaporanDataOrangtua,
        FormPelaporanKematian,
        FormPelaporanPelapor,
        FormPelaporanSaksi,
        FormPelaporanLahirMati,
        FormPelaporanPembetulanPembatalanAkta,
        FormPelaporanPengakuanAnak,
        FormPelaporanPengangkatanAnak,
        FormPelaporanPengesahanAnak,
        FormPelaporanPerceraian,
        FormPelaporanPeristiwaPenting,
        FormPelaporanPerkawinan,
        FormPelaporanPerubahanNama,
        FormPelaporanPerubahanStatusKewarganegaraan,
        FormPelaporanSubjekAktaKedua,
        FormPelaporanSubjekAktaKesatu,
        FormBiodata,
        FormBiodataWni,
        FormPendaftaranKependudukan,
        FormPendaftaranPerpindahanPenduduk,
        FormSkPindahLuarNegeri,
        FormSpPerubahanData,
        FormSpTidakMemilikiDokumen,
        FormSptjmKawinBelumCatat,
        FormSptjmKelahiran,
        FormSptjmSuamiIstri,
        FormPendudukNonPermanen
    },
    computed: {
        dataPermohonan(){
            return this.$store.getters.getDataPermohonan
        },
        layananSelected(){
            return this.$store.getters.getLayananSelected
        },
        namaRole(){
            return this.$store.getters.getAuthService.currentRole.nama_role
        }
    },
    methods: {
        checkValidForm(){
            let allValid = true
            this.dataPermohonan.form.forEach(e => {
                // console.log('e',e)
                // console.log('e.form_data', e.form_data)
                if(!e.form_data && e.is_wajib === 1){
                    allValid = false
                    // console.log('null')
                } else {
                    // console.log('set')
                }
            })
            this.allFormValid = allValid
        },
        nextStep(){
            let button = document.querySelector('#btnNext')
            let buttonHtml = button.innerHTML

            button.setAttribute('disabled', true)
            button.innerHTML = 'Selanjutnya<i class="fa fa-spin fa-spinner pl-2"></i>'

            let dataPermohonan = this.$store.getters.getDataPermohonan
            let idDataPermohonan = dataPermohonan.id_data_permohonan

            let formDataPermohonan = new FormData()
            formDataPermohonan.append('tahap', 4)
            formDataPermohonan.append('id_paket_layanan', this.layananSelected.paket_layanan.id_paket_layanan)

            let role = this.$store.getters.getAuthService.currentRole.nama_role
            if(role === 'Operator Desa'){
                formDataPermohonan.append('is_operator_desa', 1)
            }

            this.$store.dispatch('updatePermohonanPenduduk', {id: idDataPermohonan, form: formDataPermohonan}).then(res => {
                if(res.data.status){
                    
                    let dispatch = 'showDataPermohonanPenduduk'
                    if(this.namaRole == 'Penduduk'){
                        dispatch = 'showDataPermohonanPenduduk'
                    } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                        dispatch = 'showDataPermohonanPendudukByDesa'
                    } else if(this.namaRole == 'Operator Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByKecamatan'
                    } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByDukcapil'
                    }
                    
                    this.$store.dispatch(dispatch, idDataPermohonan)
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
                button.removeAttribute('disabled')
                button.innerHTML = buttonHtml
            }).catch(err => {
                switch(err.response.status){
                    case 500:
                        this.$router.push({path: '/500'})
                        break;

                    case 400:
                        swal({
                            title: "Gagal",
                            text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                    
                    default:
                        swal({
                            title: "Gagal",
                            text: err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                }
                button.removeAttribute('disabled')
                button.innerHTML = buttonHtml
            })
        },
        formManual(){
            // set dia ngisi form manual
            let dataPermohonan = this.$store.getters.getDataPermohonan
            let idDataPermohonan = dataPermohonan.id_data_permohonan

            let formDataPermohonan = new FormData()
            formDataPermohonan.append('tahap', 5)
            formDataPermohonan.append('is_form_online', 2)
            formDataPermohonan.append('id_paket_layanan', this.layananSelected.paket_layanan.id_paket_layanan)
            
            let role = this.$store.getters.getAuthService.currentRole.nama_role
            if(role === 'Operator Desa' || role === 'Rumah Sakit'){
                formDataPermohonan.append('is_operator_desa', 1)
            }
            this.$store.dispatch('updatePermohonanPenduduk', {id: idDataPermohonan, form: formDataPermohonan}).then(res => {
                if(res.data.status){
                    let dispatch = 'showDataPermohonanPenduduk'
                    if(this.namaRole == 'Penduduk'){
                        dispatch = 'showDataPermohonanPenduduk'
                    } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                        dispatch = 'showDataPermohonanPendudukByDesa'
                    } else if(this.namaRole == 'Operator Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByKecamatan'
                    } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByDukcapil'
                    } else if(this.namaRole == 'Rumah Sakit'){
                        dispatch = 'showDataPermohonanPendudukByRumahSakit'
                    }
                    
                    this.$store.dispatch(dispatch, idDataPermohonan)
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
            })
        },
        setStep(val){
            let dataPermohonan = this.$store.getters.getDataPermohonan
            let idDataPermohonan = dataPermohonan.id_data_permohonan

            let formDataPermohonan = new FormData()
            formDataPermohonan.append('tahap', val)
            formDataPermohonan.append('id_paket_layanan', this.layananSelected.paket_layanan.id_paket_layanan)
            
            let role = this.$store.getters.getAuthService.currentRole.nama_role
            if(role === 'Operator Desa'){
                formDataPermohonan.append('is_operator_desa', 1)
            }
            this.$store.dispatch('updatePermohonanPenduduk', {id: idDataPermohonan, form: formDataPermohonan}).then(res => {
                if(res.data.status){
                    let dispatch = 'showDataPermohonanPenduduk'
                    if(this.namaRole == 'Penduduk'){
                        dispatch = 'showDataPermohonanPenduduk'
                    } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                        dispatch = 'showDataPermohonanPendudukByDesa'
                    } else if(this.namaRole == 'Operator Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByKecamatan'
                    } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByDukcapil'
                    } else if(this.namaRole == 'Rumah Sakit'){
                        dispatch = 'showDataPermohonanPendudukByRumahSakit'
                    }
                    
                    this.$store.dispatch(dispatch, idDataPermohonan)
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
            }).catch(err => {
                switch(err.response.status){
                    case 500:
                        this.$router.push({path: '/500'})
                        break;

                    case 400:
                        swal({
                            title: "Gagal",
                            text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                    
                    default:
                        swal({
                            title: "Gagal",
                            text: err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                }
            })
        },
        initForm(){
            // hanya yang sudah punya ttd digital yang bisa isi form online
            if(!this.$store.getters.getTtdUser){
                swal({
                    title: "Edit Profil",
                    text: "Untuk mengisi form online, diperlukan tanda tangan digital pelapor. Silahkan ke menu profil, lalu upload tanda tangan digital anda.",
                    icon: "warning",
                    buttons: "Ok"
                }).then(res => {
                    if(res){
                        this.$router.push({path: '/profil'})
                    }
                })
                return false
            }

            // saat ini hanya penduduk yang bisa isi online
            let role = this.$store.getters.getAuthService.currentRole.nama_role

            if(role != 'Penduduk'){
                swal({
                    title: "Tidak tersedia",
                    text: "Saat ini hanya penduduk yang dapat mengisi form secara online. Silahkan pilih pengisian secara offline.",
                    icon: "error",
                    buttons: "Ok"
                })
                return false
            }

            // set dia ngisi permohonan online
            
            let dataPermohonan = this.$store.getters.getDataPermohonan
            let idDataPermohonan = dataPermohonan.id_data_permohonan

            let formDataPermohonan = new FormData()
            formDataPermohonan.append('is_form_online', 1)

            if(role === 'Operator Desa'){
                formDataPermohonan.append('is_operator_desa', 1)
            }

            this.$store.dispatch('updatePermohonanPenduduk', {id: idDataPermohonan, form: formDataPermohonan}).then(res => {
                if(res.data.status){
                    let dispatch = 'showDataPermohonanPenduduk'
                    if(this.namaRole == 'Penduduk'){
                        dispatch = 'showDataPermohonanPenduduk'
                    } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                        dispatch = 'showDataPermohonanPendudukByDesa'
                    } else if(this.namaRole == 'Operator Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByKecamatan'
                    } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByDukcapil'
                    } else if(this.namaRole == 'Rumah Sakit'){
                        dispatch = 'showDataPermohonanPendudukByRumahSakit'
                    }
                    
                    this.$store.dispatch(dispatch, idDataPermohonan)
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
            })


            // jika punya form pelaporan
            let form = this.dataPermohonan.paket_layanan.layanan.layanan_dokumen
            
            let isHasFormPelaporan = false
            form.forEach(e => {
                if(e.dokumen.kode_dokumen === 'F2.01'){
                    isHasFormPelaporan = true
                }
            })

            if(isHasFormPelaporan){
                this.initFormPelaporan()
            } else {
                this.loadForm()
            }

            

            
        },
        initFormPelaporan(){
            let role = this.$store.getters.getAuthService.currentRole.nama_role

            let formPelaporan = new FormData()
            let idDataPermohonan = this.dataPermohonan.id_data_permohonan
            formPelaporan.append('id_data_permohonan', idDataPermohonan)

            let dispatchPelaporan = 'storeFormPelaporan'

            if(role === 'Operator Desa'){
                formPelaporan.append('id_penduduk', this.$store.getters.getPendudukBantu.id_penduduk)
            }

            
            this.$store.dispatch(dispatchPelaporan, formPelaporan).then(res => {
                // console.log(res)
                if(res.data.status){
                    this.showFormJenisPelaporan = true
                    this.$store.dispatch('setFormPelaporan', res.data.data)
                }
            })
        },
        loadForm(){
            this.showForm = true
            
            let idDataPermohonan = this.dataPermohonan.id_data_permohonan
            let dispatch = 'showDataPermohonanPenduduk'
            if(this.namaRole == 'Penduduk'){
                dispatch = 'showDataPermohonanPenduduk'
            } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                dispatch = 'showDataPermohonanPendudukByDesa'
            } else if(this.namaRole == 'Operator Kecamatan'){
                dispatch = 'showDataPermohonanPendudukByKecamatan'
            } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                dispatch = 'showDataPermohonanPendudukByDukcapil'
            } else if(this.namaRole == 'Rumah Sakit'){
                dispatch = 'showDataPermohonanPendudukByRumahSakit'
            }
            this.$store.dispatch(dispatch, idDataPermohonan)
        },
        handleSuccess(){
            let idDataPermohonan = this.dataPermohonan.id_data_permohonan
            this.$store.dispatch('showDataPermohonanPenduduk', idDataPermohonan)
            
        },
        checkHasFillForm(){
            let hasFillForm = false
            if(this.dataPermohonan.form){
                this.dataPermohonan.form.forEach(e => {
                    if(e.form_data){
                        hasFillForm = true
                    }
                })
            }
            

            if(hasFillForm){
                this.initForm()
            }
        },
        checkHasForm(){
            let hasForm = false
            // console.log(this.layananSelected)
            this.layananSelected.layanan_dokumen.forEach(e => {
                if(e.dokumen.kode_dokumen){
                    hasForm = true
                }
            })

            if(hasForm){
                this.hasForm = hasForm

                // cek sudah isi form?
                // kalau sudah isi form, langsung aja show form
                this.checkHasFillForm()
            } else {
                swal({
                    title: "Silahkan Lanjutkan",
                    text: "Tidak ada formulir yang perlu diisi, silahkan lanjutkan ke tahap upload berkas.",
                    icon: "success",
                    buttons: {
                        ok: {
                            text: "Ok",
                            value: "ok",
                        },
                    }
                }).then( val => {
                    if(val === 'ok'){
                        this.setStep(5)
                    }
                })
            }
        },
        checkUbahIsiForm(){
            if(this.dataPermohonan.is_form_online === 0){
                this.showForm = false
                this.showFormJenisPelaporan = false
            }
        }
    },
    mounted(){
        let idDataPermohonan = this.dataPermohonan.id_data_permohonan

        let dispatch = 'showDataPermohonanPenduduk'
        if(this.namaRole == 'Penduduk'){
            dispatch = 'showDataPermohonanPenduduk'
        } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
            dispatch = 'showDataPermohonanPendudukByDesa'
        } else if(this.namaRole == 'Operator Kecamatan'){
            dispatch = 'showDataPermohonanPendudukByKecamatan'
        } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
            dispatch = 'showDataPermohonanPendudukByDukcapil'
        } else if(this.namaRole == 'Rumah Sakit'){
            dispatch = 'showDataPermohonanPendudukByRumahSakit'
        }
        
        this.$store.dispatch(dispatch, idDataPermohonan)
        this.checkHasForm()
    },
    watch:{
        dataPermohonan(newVal, oldVal){
            // console.log('datapermohonan change')
            // console.log(newVal)
            this.checkValidForm()
            this.checkUbahIsiForm()
        }
    }
}
</script>